export default __webpack_public_path__ + "static/media/foot_logo.c24bb79e.svg";